import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from '../../../services/auth.service';
import { CardService } from '../../../services/card.service';
import { CreditService } from '../../../services/credit.service';

import { isEmpty } from '../../../helpers/object';
import { ProfileTransactionComponent } from './profile-transaction/profile-transaction.component';

import { IUser } from '../../../models/user/user.model';
import { select, Store } from '@ngrx/store';
import { UserState } from 'src/app/store/reducers/user';

@Component({
  selector: 'app-client-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.css'],
  entryComponents: [ProfileTransactionComponent],
})
export class ClientWalletComponent implements OnInit {
  private _creditAmount = 30;
  private _modal;
  public defaultCart: object;
  public currentUser: IUser;
  public stripeCheck: Subject<object> = new Subject<object>();
  public transactionSubject: Subject<void> = new Subject<void>();
  public activePayment = 'paypal';

  constructor(
    private _authService: AuthService,
    public cardService: CardService,
    public creditService: CreditService,
    private _modalService: NgbModal,
    private _userStore: Store<UserState>
  ) {}

  ngOnInit() {
    this._userStore.pipe(select('user')).subscribe((data: UserState) => {
      this.currentUser = data.activeUser;
    });
    this.cardService.initDefaultCard();

    this.cardService.defaultCard.subscribe((card: object) => {
      this.defaultCart = card;
    });
  }

  set creditAmount(amount: number) {
    this._creditAmount = amount;
  }

  get creditAmount() {
    return this._creditAmount;
  }

  stripeTokenHandles(token: string) {
    this.cardService.addCard(token).subscribe((card: object) => {
      this._addCredit({ amount: this._creditAmount });
    });
  }

  open(content) {
    this._modal = this._modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
    });
  }

  emitEventStripeCheck(options: object = {}) {
    this.stripeCheck.next(options);
  }

  addCredit(defaultCart: object) {
    if (isEmpty(this.defaultCart)) {
      this.emitEventStripeCheck();
    } else {
      this._addCredit({ amount: this._creditAmount });
    }
  }

  private _addCredit(options: object) {
    this.creditService.addCreditByDefaultCard(options).subscribe(() => {
      this.paymentExecutedHandler();
    });
  }

  addCard(): void {
    this.emitEventStripeCheck();
  }

  async addedStripeCard() {
    await this._authService.currentUserObservable();
    this.cardService.initDefaultCard();
    this._modal.close();
  }

  setActivePayment(val: string) {
    this.activePayment = val;
  }

  isActivePayment(type: string) {
    return this.activePayment === type;
  }

  paymentExecutedHandler() {
    this.transactionSubject.next();
    this._authService.currentUserObservable();
    this.cardService.initDefaultCard();
  }

  paginateComponentRef() {
    return ProfileTransactionComponent;
  }
}
